export const SortIcons = ({ type, size = 24, color }) => {
  const icons = {
    layout: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M3.33301 4.16634C3.33301 3.94533 3.42081 3.73337 3.57709 3.57709C3.73337 3.42081 3.94533 3.33301 4.16634 3.33301H7.49967C7.72069 3.33301 7.93265 3.42081 8.08893 3.57709C8.24521 3.73337 8.33301 3.94533 8.33301 4.16634V7.49967C8.33301 7.72069 8.24521 7.93265 8.08893 8.08893C7.93265 8.24521 7.72069 8.33301 7.49967 8.33301H4.16634C3.94533 8.33301 3.73337 8.24521 3.57709 8.08893C3.42081 7.93265 3.33301 7.72069 3.33301 7.49967V4.16634Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.6663 4.16634C11.6663 3.94533 11.7541 3.73337 11.9104 3.57709C12.0667 3.42081 12.2787 3.33301 12.4997 3.33301H15.833C16.054 3.33301 16.266 3.42081 16.4223 3.57709C16.5785 3.73337 16.6663 3.94533 16.6663 4.16634V7.49967C16.6663 7.72069 16.5785 7.93265 16.4223 8.08893C16.266 8.24521 16.054 8.33301 15.833 8.33301H12.4997C12.2787 8.33301 12.0667 8.24521 11.9104 8.08893C11.7541 7.93265 11.6663 7.72069 11.6663 7.49967V4.16634Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.33301 12.4997C3.33301 12.2787 3.42081 12.0667 3.57709 11.9104C3.73337 11.7541 3.94533 11.6663 4.16634 11.6663H7.49967C7.72069 11.6663 7.93265 11.7541 8.08893 11.9104C8.24521 12.0667 8.33301 12.2787 8.33301 12.4997V15.833C8.33301 16.054 8.24521 16.266 8.08893 16.4223C7.93265 16.5785 7.72069 16.6663 7.49967 16.6663H4.16634C3.94533 16.6663 3.73337 16.5785 3.57709 16.4223C3.42081 16.266 3.33301 16.054 3.33301 15.833V12.4997Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.6663 12.4997C11.6663 12.2787 11.7541 12.0667 11.9104 11.9104C12.0667 11.7541 12.2787 11.6663 12.4997 11.6663H15.833C16.054 11.6663 16.266 11.7541 16.4223 11.9104C16.5785 12.0667 16.6663 12.2787 16.6663 12.4997V15.833C16.6663 16.054 16.5785 16.266 16.4223 16.4223C16.266 16.5785 16.054 16.6663 15.833 16.6663H12.4997C12.2787 16.6663 12.0667 16.5785 11.9104 16.4223C11.7541 16.266 11.6663 16.054 11.6663 15.833V12.4997Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        arrow-stoke
      </svg>
    ),
    layoutSelect: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M3.33398 4.16634C3.33398 3.94533 3.42178 3.73337 3.57806 3.57709C3.73434 3.42081 3.9463 3.33301 4.16732 3.33301H7.50065C7.72166 3.33301 7.93363 3.42081 8.08991 3.57709C8.24619 3.73337 8.33398 3.94533 8.33398 4.16634V7.49967C8.33398 7.72069 8.24619 7.93265 8.08991 8.08893C7.93363 8.24521 7.72166 8.33301 7.50065 8.33301H4.16732C3.9463 8.33301 3.73434 8.24521 3.57806 8.08893C3.42178 7.93265 3.33398 7.72069 3.33398 7.49967V4.16634Z"
          stroke="url(#paint0_linear_1617_84891)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.6673 4.16634C11.6673 3.94533 11.7551 3.73337 11.9114 3.57709C12.0677 3.42081 12.2796 3.33301 12.5007 3.33301H15.834C16.055 3.33301 16.267 3.42081 16.4232 3.57709C16.5795 3.73337 16.6673 3.94533 16.6673 4.16634V7.49967C16.6673 7.72069 16.5795 7.93265 16.4232 8.08893C16.267 8.24521 16.055 8.33301 15.834 8.33301H12.5007C12.2796 8.33301 12.0677 8.24521 11.9114 8.08893C11.7551 7.93265 11.6673 7.72069 11.6673 7.49967V4.16634Z"
          stroke="url(#paint1_linear_1617_84891)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.33398 12.4997C3.33398 12.2787 3.42178 12.0667 3.57806 11.9104C3.73434 11.7541 3.9463 11.6663 4.16732 11.6663H7.50065C7.72166 11.6663 7.93363 11.7541 8.08991 11.9104C8.24619 12.0667 8.33398 12.2787 8.33398 12.4997V15.833C8.33398 16.054 8.24619 16.266 8.08991 16.4223C7.93363 16.5785 7.72166 16.6663 7.50065 16.6663H4.16732C3.9463 16.6663 3.73434 16.5785 3.57806 16.4223C3.42178 16.266 3.33398 16.054 3.33398 15.833V12.4997Z"
          stroke="url(#paint2_linear_1617_84891)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.6673 12.4997C11.6673 12.2787 11.7551 12.0667 11.9114 11.9104C12.0677 11.7541 12.2796 11.6663 12.5007 11.6663H15.834C16.055 11.6663 16.267 11.7541 16.4232 11.9104C16.5795 12.0667 16.6673 12.2787 16.6673 12.4997V15.833C16.6673 16.054 16.5795 16.266 16.4232 16.4223C16.267 16.5785 16.055 16.6663 15.834 16.6663H12.5007C12.2796 16.6663 12.0677 16.5785 11.9114 16.4223C11.7551 16.266 11.6673 16.054 11.6673 15.833V12.4997Z"
          stroke="url(#paint3_linear_1617_84891)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1617_84891"
            x1="10.0007"
            y1="16.6663"
            x2="10.0007"
            y2="3.33301"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={color} />
            <stop offset="1" stopColor={color} />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1617_84891"
            x1="10.0007"
            y1="16.6663"
            x2="10.0007"
            y2="3.33301"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={color} />
            <stop offset="1" stopColor={color} />
          </linearGradient>
          <linearGradient
            id="paint2_linear_1617_84891"
            x1="10.0007"
            y1="16.6663"
            x2="10.0007"
            y2="3.33301"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={color} />
            <stop offset="1" stopColor={color} />
          </linearGradient>
          <linearGradient
            id="paint3_linear_1617_84891"
            x1="10.0007"
            y1="16.6663"
            x2="10.0007"
            y2="3.33301"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={color} />
            <stop offset="1" stopColor={color} />
          </linearGradient>
        </defs>
      </svg>
    ),
    base: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="12"
        viewBox="0 0 15 12"
        fill="none"
      >
        <path
          d="M4.49935 1H13.666M4.49935 6H13.666M4.49935 11H13.666M1.16602 1V1.00833M1.16602 6V6.00833M1.16602 11V11.0083"
          stroke="url(#paint0_linear_1938_4094)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1938_4094"
            x1="7.41602"
            y1="11.0083"
            x2="7.41602"
            y2="1"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={color} />
            <stop offset="1" stopColor={color} />
          </linearGradient>
        </defs>
      </svg>
    ),
    baseSelect: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M7.49935 5H16.666M7.49935 10H16.666M7.49935 15H16.666M4.16602 5V5.00833M4.16602 10V10.0083M4.16602 15V15.0083"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    order: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <g clipPath="url(#clip0_1938_7211)">
          <path
            d="M11.668 7.5L14.168 5L16.668 7.5"
            stroke="#7D708A"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.16797 4.58366C4.16797 4.47315 4.21187 4.36717 4.29001 4.28903C4.36815 4.21089 4.47413 4.16699 4.58464 4.16699H7.91797C8.02848 4.16699 8.13446 4.21089 8.2126 4.28903C8.29074 4.36717 8.33464 4.47315 8.33464 4.58366V7.91699C8.33464 8.0275 8.29074 8.13348 8.2126 8.21162C8.13446 8.28976 8.02848 8.33366 7.91797 8.33366H4.58464C4.47413 8.33366 4.36815 8.28976 4.29001 8.21162C4.21187 8.13348 4.16797 8.0275 4.16797 7.91699V4.58366Z"
            stroke="#7D708A"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.16797 12.0837C4.16797 11.9732 4.21187 11.8672 4.29001 11.789C4.36815 11.7109 4.47413 11.667 4.58464 11.667H7.91797C8.02848 11.667 8.13446 11.7109 8.2126 11.789C8.29074 11.8672 8.33464 11.9732 8.33464 12.0837V15.417C8.33464 15.5275 8.29074 15.6335 8.2126 15.7116C8.13446 15.7898 8.02848 15.8337 7.91797 15.8337H4.58464C4.47413 15.8337 4.36815 15.7898 4.29001 15.7116C4.21187 15.6335 4.16797 15.5275 4.16797 15.417V12.0837Z"
            stroke="#7D708A"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.168 5V15"
            stroke="#7D708A"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1938_7211">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    arrow: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M4 6L8 10L12 6"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  };

  return icons[type];
};

export default SortIcons;
